export const problems = [
  {
    "title": "Another unit to plan from scratch",
    "text": "You need activities that connect across the whole school year, with a clear reason for teaching each one."
  },
  {
    "title": "The class waits while you set up",
    "text": "You are placing markers and explaining positions while students wait for a turn."
  },
  {
    "title": "Big groups, long lines",
    "text": "Without clear groups and rotations, too much lesson time disappears into queues."
  },
  {
    "title": "Mixed levels in the same lesson",
    "text": "Some students need a shorter pass. Others need another decision. You need both options ready."
  },
  {
    "title": "Too many decisions on the spot",
    "text": "The activity still needs an explanation, a stop signal, a reset and a correction when it goes wrong."
  },
  {
    "title": "Progress is hard to see",
    "text": "You need to know what to observe today and what the class should work on next."
  }
];
